// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"cf02edb8","container":"f88802a0","deleteButton":"f7ed72af","user":"f554b65b"};